import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import classes from "classnames";
import { withSnackbar } from "notistack";
import React from "react";
import { FormattedMessage } from "react-intl";
import StarRatingComponent from "Library/react-star-rating-component";
import { instance } from "../../../../Actions/AxiosInstance";
import createstore from "../../../../store";

class EmpSkillForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: this.props.data,
      isdefault: false,
      rating: this.props.data.rating || null,
      skill: this.props.data.skill || null,
      employeeskillid: this.props.data.employeeskillid || null,
    };
    this.onCancel = this.onCancel.bind(this);
  }

  componentWillMount() {
    const { SubscriptionInfo } = createstore.getState();
    const { accountid } = SubscriptionInfo.SubscriptionData;
    const { subscriptionid } = SubscriptionInfo.SubscriptionData;
    const { countrytimezoneid } = SubscriptionInfo.SubscriptionData;
    const { employeeid } = SubscriptionInfo.SubscriptionData;
    this.setState(
      {
        accountid,
        subscriptionid,
        countrytimezoneid,
        employeeid,
      },
      () => { },
    );
  }

  UpdateSkills(e) {
    this.setState({ skill: e.target.value });
  }

  UpadateRating(nextValue, prevValue, name) {
    this.setState({ rating: nextValue });
  }

  // onHoverIn(nextValue, prevValue, name) {
  //     this.setState({ rating: nextValue });
  // }

  AddSkills() {
    const data = {
      employeeskillid: this.state.employeeskillid,
      skill: this.state.skill,
      rating: this.state.rating,
      employeeid: this.props.colleagueid || this.state.employeeid,
    };
    if (!createstore.getState().AuthenticationAction.IsFulfilled) {
      Object.assign(data, {
        accountid: this.state.accountid,
        subscriptionid: this.state.subscriptionid,
        timezoneid: this.state.countrytimezoneid,
        employeeid: this.props.colleagueid || this.state.employeeid,
      });
    }
    const URL = "employee/insertupdateempskill";
    instance
      .post(URL, data)
      .then((result) => {
        this.setState(
          {
            skill: "",
            rating: "",
            defaultmsg: false,
            employeeskillid: "",
            EditPerticularSkill: false,
            isEdit: false,
          },
          this.props.SetFlag(3, true),
        );
      })
      .catch((error) => {
        // this.setState({ isbuttonDisabled: false, expanded: false });
        const CommonError = error.response ? error.response.data.error.message : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  onCancel() {
    this.props.SetFlag(3, true);
  }

  render() {
    return (
      <div className="emp-from-wrapper imp-dates">
        <div className="form-height">
          <div id="div">
            <div className="custom-form-box profile-banking" autoComplete="off">
              <div className="inner-wrapper opaque" tabIndex="0">
                <div className="margin-bottom-20">
                  <p className="input-form-label">
                    <FormattedMessage id="LbSkillName" defaultMessage="Skill Name" />{" "}
                  </p>
                  <div>
                    <TextField
                      id="outlined-bare"
                      label=""
                      // defaultValue={<FormattedMessage id="LbTypeYourSkill" defaultMessage="Type Your Skill" />}
                      placeholder="Type Your Skill"
                      className="expense-cycle-input width50 skill"
                      margin="dense"
                      variant="outlined"
                      onChange={this.UpdateSkills.bind(this)}
                      value={this.state.skill}
                      inputProps={{ maxLength: 40 }}
                      autoFocus
                    />
                  </div>
                  <p className="input-form-label margin-top-10">
                    <FormattedMessage id="LbRating" defaultMessage="Ratings" />{" "}
                  </p>
                  <div className="rating-icons width50">
                    <StarRatingComponent
                      name="rate1"
                      starCount={5}
                      value={this.state.rating}
                      starColor="#166ab3"
                      onStarClick={this.UpadateRating.bind(this)}
                      // onStarHover={this.onHoverIn.bind(this)}
                      // onStarHoverOut={this.onHoverOut.bind(this)}
                      className="aaa rating"
                    />
                  </div>
                </div>
              </div>

              <div className="upform-footer">
                <Button
                  id="save"
                  variant="contained"
                  color="primary"
                  size="large"
                  className={classes.button}
                  onClick={this.AddSkills.bind(this)}
                >
                  <FormattedMessage id="BtSave" defaultMessage="Save" />
                </Button>
                <span className="margin-left-16"></span>
                <Button size="large" onClick={this.onCancel} className="Cancel">
                  <FormattedMessage id="BtCancel" defaultMessage="Cancel" />
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withSnackbar(EmpSkillForm);
